/* eslint-disable react/prop-types */
import React from 'react';
import AsyncSelect from 'react-select/async';
// helpers
import { selectStyles } from '../../helpers';

const AsyncSelectReact = ({
  name,
  error,
  label,
  value,
  isMulti,
  touched,
  required,
  className,
  handleBlur,
  isClearable,
  handleFocus,
  loadOptions,
  placeholder,
  handleChange,
  loadingMessage,
  noOptionsMessage,
}) => (
  <>
    <div className={`form-outline mb-4 DashBoardInputBx${className ? ` ${className}` : ''}`}>
      <label id={name} className='form-label' htmlFor={name}>
        {label}
        {required && <span className='RedStar'>*</span>}
      </label>
      <AsyncSelect
        name={name}
        value={value}
        isMulti={isMulti}
        onBlur={handleBlur}
        onFocus={handleFocus}
        styles={selectStyles}
        onChange={handleChange}
        isClearable={isClearable}
        loadOptions={loadOptions}
        placeholder={placeholder}
        loadingMessage={loadingMessage}
        noOptionsMessage={noOptionsMessage}
        className={`${touched && error && 'input-error-react-select'}`}
      />
      {
        touched && error && (
          <div className='text-danger'>{error}</div>
        )
      }
    </div>
  </>
);

export default AsyncSelectReact;
